/*
  Hanakini – colour-matched "Pairs well with" (Oct 2026)
  Builds the slider from the ranked cards rendered by snippets/hk-pairs-list.liquid
  and re-fetches them (sections/hk-pairs.liquid) when the shopper changes colour.
*/
(function () {
  if (window.__hkPairs) return;
  window.__hkPairs = true;

  function build(root, results) {
    var count = parseInt(root.dataset.count, 10) || 4;
    var perSlide = parseInt(root.dataset.perSlide, 10) || 2;
    var controls = root.dataset.controls || 'dots';
    var cards = results ? Array.prototype.slice.call(results.querySelectorAll(':scope > .grid-product'), 0, count) : [];
    var body = root.querySelector('.hk-pairs__body');

    if (root.__hkFlickity && typeof root.__hkFlickity.destroy === 'function') {
      try { root.__hkFlickity.destroy(); } catch (e) {}
    }
    root.__hkFlickity = null;

    if (!cards.length) {
      root.style.display = 'none';
      body.innerHTML = '';
      return;
    }
    root.style.display = '';
    root.dataset.hkColor = results.getAttribute('data-hk-color') || '';

    var wrap = document.createElement('div');
    wrap.className = 'product-recommendations';
    var slider = document.createElement('div');
    slider.className = 'product-single__related grid grid--uniform';
    slider.setAttribute('data-slideshow', '');
    slider.dataset.controls = controls;
    slider.dataset.perSlide = perSlide;
    slider.dataset.count = cards.length;
    var slide;
    cards.forEach(function (card, i) {
      if (i % perSlide === 0) {
        slide = document.createElement('div');
        slide.className = 'product-recommendations__slide';
        slider.appendChild(slide);
      }
      slide.appendChild(card);
    });
    wrap.appendChild(slider);
    body.innerHTML = '';
    body.appendChild(wrap);

    try { if (window.theme && theme.reinitProductGridItem) theme.reinitProductGridItem(root); } catch (e) {}
    if (perSlide < cards.length && window.theme && theme.Slideshow) {
      try {
        root.__hkFlickity = new theme.Slideshow(slider, {
          prevNextButtons: controls === 'arrows',
          pageDots: controls !== 'arrows',
          adaptiveHeight: true,
          wrapAround: false
        });
      } catch (e) {}
    }
  }

  function init(root) {
    if (root.__hkInit) return;
    root.__hkInit = true;
    build(root, root.querySelector('.hk-pairs__results'));

    var pending = 0;
    document.addEventListener('variant:change', function (evt) {
      var v = evt.detail && evt.detail.variant;
      if (!v || !v.id) return;
      var ticket = ++pending;
      var url = root.dataset.url + (root.dataset.url.indexOf('?') > -1 ? '&' : '?') +
        'variant=' + v.id + '&section_id=hk-pairs';
      fetch(url, { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          if (ticket !== pending) return; // a newer colour was picked meanwhile
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var results = tmp.querySelector('.hk-pairs__results');
          if (!results) return;
          if ((results.getAttribute('data-hk-color') || '') === root.dataset.hkColor) return; // size change only
          build(root, results);
        })
        .catch(function () {});
    });
  }

  // Re-use the theme's own "complementary" styling (compact horizontal cards)
  function cloneThemeCss() {
    if (document.getElementById('hk-pairs-css')) return;
    var needle = 'product-recommendations[data-intent="complementary"]';
    var css = [];
    function walk(rules) {
      var out = [];
      for (var i = 0; i < rules.length; i++) {
        var r = rules[i];
        if (r.type === 4 && r.cssRules) { // @media
          var inner = walk(r.cssRules);
          if (inner.length) out.push('@media ' + r.conditionText + '{' + inner.join('') + '}');
        } else if (r.selectorText && r.selectorText.indexOf(needle) > -1) {
          out.push(r.cssText.split(needle).join('[data-hk-pairs]'));
        }
      }
      return out;
    }
    for (var s = 0; s < document.styleSheets.length; s++) {
      var rules;
      try { rules = document.styleSheets[s].cssRules; } catch (e) { continue; }
      if (rules) css = css.concat(walk(rules));
    }
    var style = document.createElement('style');
    style.id = 'hk-pairs-css';
    style.textContent = '[data-hk-pairs]{display:block;overflow:hidden}' +
      // no size banner on hover here – collection pages keep theirs
      '[data-hk-pairs] .variant-custom-body,[data-hk-pairs] .variant-inner-data{display:none!important}' +
      css.join('\n');
    document.head.appendChild(style);
  }

  function start() {
    cloneThemeCss();
    document.querySelectorAll('[data-hk-pairs]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
